import React, { Component } from 'react';
import { connect } from 'react-redux';
import { breadcrumbs } from '../../../../actions/appActions';
import { push } from 'react-router-redux';
import { OfficialsActiveOvm } from '../../components/grids/OfficialGrid';
import { StatementTypeRaw } from "../../enum";
import Button from '../../../../components/form/Button';
import { noop } from 'lodash';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import DatePicker from "../../../../components/form/DateTime/DateTime";
import { FormControl } from "@mui/material";
import * as moment from 'moment';

class OvmMissingOfficials extends Component {
  state = {
    statementType: "",
    deadlineFrom: moment().subtract(1, "month").toDate(),
    deadlineTo: moment().toDate(),
    ongoingYearSelected: new Date().getFullYear(),
    query: null,
    filterError: ''
  };

  componentDidMount() {
    this.props.breadcrumbs([
      { label: 'Funkcionáři s chybějícím oznámením' },
    ]);
    const saved = JSON.parse(window.localStorage.getItem('ovmMissingOfficialsGrid_filter'));
    if (saved) {
      this.setState({
        statementType: saved.statementType ?? "",
        deadlineFrom: saved.deadlineFrom ? new Date(saved.deadlineFrom) : this.state.deadlineFrom,
        deadlineTo: saved.deadlineTo ? new Date(saved.deadlineTo) : this.state.deadlineTo,
        ongoingYearSelected: saved.ongoingYearSelected ?? new Date().getFullYear()
      }, () => this.applyFilter());
    } else {
      this.applyFilter();
    }
  }

  applyFilter = () => {
    const { statementType, deadlineFrom, deadlineTo } = this.state;

    const query = {
      ...statementType ? { type: statementType } : {},
      deadlineFrom: this.formatDate(deadlineFrom, "YYYY-MM-DD"),
      deadlineTo: this.formatDate(deadlineTo, "YYYY-MM-DD"),
    };
    this.setState({ query });
    this.saveFilter();
  }

  formatDate = (date, dateFormat = "D.M.YYYY") => {
    if (!date) return null;

    return moment(date).format(dateFormat);
  };

  saveFilter = () => {
    const { statementType, deadlineFrom, deadlineTo, ongoingYearSelected } = this.state;
    window.localStorage.setItem('ovmMissingOfficialsGrid_filter', JSON.stringify({
      statementType,
      deadlineFrom: deadlineFrom ? deadlineFrom.toISOString() : null,
      deadlineTo: deadlineTo ? deadlineTo.toISOString() : null,
      ongoingYearSelected: ongoingYearSelected
    }));
  }

  onRowClick = ({ id }) => {
    this.props.push(`${this.props.auth.startUrl}/funkcionari/form/${id}`);
  };

  onDeadlineChange = (date, field) => {
    this.setState({ [field]: date, filterError: '' }, () => {
      if (this.state.deadlineFrom && this.state.deadlineTo && this.state.deadlineFrom > this.state.deadlineTo) {
        this.setState({ filterError: 'Období od nemůže být pozdější než období do' });
      } else if (!this.state.deadlineFrom || !this.state.deadlineTo) {
        this.setState({ filterError: 'Období musí být vyplněno' });
      } else {
        this.setState({ filterError: '' });
      }
    });
  }

  onOngoingYearChange = (year) => {
    const ongoingYearSelected = year;
    const deadlineFrom = new Date(ongoingYearSelected - 1, 6, 1);
    const deadlineTo = new Date(ongoingYearSelected, 5, 30);

    this.setState({
      ongoingYearSelected,
      deadlineFrom,
      deadlineTo
    }, () => {
      this.saveFilter();
    });
  }

  render() {
    const { auth } = this.props;
    const { statementType, deadlineFrom, deadlineTo, ongoingYearSelected, query } = this.state;

    return (
        <div className="officialStPage">
          <div className="officialStFilters">
            <div className="officialStFilters__fields">
              <label className="officialStFilters__field">
                <span className="officialStFilters__label">Druh oznámení</span>
                <FormControl>
                  <Select
                      className="officialStFilters__select"
                      value={statementType}
                      onChange={(event) => this.setState({ statementType: event.target.value })}
                      displayEmpty
                  >
                    <MenuItem value="">Všechny</MenuItem>
                    <MenuItem key={StatementTypeRaw.INGOING} value={StatementTypeRaw.INGOING}>Vstupní oznámení</MenuItem>
                    <MenuItem key={StatementTypeRaw.OUTGOING} value={StatementTypeRaw.OUTGOING}>Výstupní oznámení</MenuItem>
                    <MenuItem key={StatementTypeRaw.ONGOING} value={StatementTypeRaw.ONGOING}>Průběžné oznámení</MenuItem>
                  </Select>
                </FormControl>
              </label>
              { statementType != StatementTypeRaw.ONGOING && (
                  <>
                    <label className="officialStFilters__field">
                      <span className="officialStFilters__label">Období od</span>
                      <DatePicker
                          name="deadlineFrom"
                          onChange={(date) => this.onDeadlineChange(date, 'deadlineFrom')}
                          value={deadlineFrom}
                      />
                    </label>
                    <label className="officialStFilters__field">
                      <span className="officialStFilters__label">Období do</span>
                      <DatePicker
                          name="deadlineTo"
                          onChange={(date) => this.onDeadlineChange(date, 'deadlineTo')}
                          value={deadlineTo}
                      />
                    </label>
                  </>
              )}
              { /*statementType == StatementTypeRaw.ONGOING && (
                  <>
                    <label className="officialStFilters__field">
                      <span className="officialStFilters__label">Oznámení za rok</span>
                      <FormControl>
                        <Select
                            className="officialStFilters__select"
                            value={ongoingYearSelected}
                            onChange={(event) => this.onOngoingYearChange(event.target.value)}
                            displayEmpty
                        >
                          { [...Array(new Date().getFullYear() - 2017 + 1).keys()].map(i => {
                            const year = new Date().getFullYear() - i;
                            return <MenuItem key={year} value={year}>{year}</MenuItem>;
                          })}
                        </Select>
                      </FormControl>
                    </label>
                    <label className="officialStFilters__field">
                      <span className="officialStFilters__label">Termín podání</span>
                      {this.formatDate(deadlineFrom)} - {this.formatDate(deadlineTo)}
                    </label>
                  </>
              )*/}
            </div>
            {!this.state.filterError && (
                <div className="officialStFilters__actions">
                  <Button type="button" label="Vyhledat" onClick={this.applyFilter} />
                </div>
            )}
            {!!this.state.filterError && (
                <div className="officialStFilters__error">
                  {this.state.filterError}
                </div>
            )}
          </div>

          {query && (
              <OfficialsActiveOvm
                  gridName="ovmMissingOfficialsGrid"
                  url={`${auth.startUrl}/api/funkcionari/chybejici`}
                  adding={false}
                  onAdd={noop}
                  deleting={false}
                  onRowClick={this.onRowClick}
                  query={query}
              />
          )}
        </div>
    );
  }
}

export default connect(null, { breadcrumbs, push })(OvmMissingOfficials);
